import { ICommentsState } from '../../types/redux/comments';
import { TReduxActions } from '../../types/redux/actions';
import { ECommentsActions } from '../../constants/actionTypes/comments';

export const defaultState: ICommentsState = {
  mainComment: '',
};

export function commentsReducer(state = defaultState, action: TReduxActions): ICommentsState {
  switch (action.type) {
    case ECommentsActions.SET_MAIN_COMMENT:
      return {
        ...state,
        mainComment: action.payload,
      };

    default:
      return state;
  }
}
